import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { BookingProvider } from './context/BookingContext';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import FloatingButtons from './components/FloatingButtons/FloatingButtons';
import Home from './pages/Home';
import About from './pages/About';
import RoomsPage from './pages/Rooms';
import RoomDetails from './pages/RoomDetails';
import Booking from './pages/Booking';
import GalleryPage from './pages/GalleryPage';
import Services from './pages/Services';
import Offers from './pages/Offers';
import TestimonialsPage from './pages/TestimonialsPage';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import './styles/global.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
  return null;
}

function NotFound() {
  return (
    <main>
      <div className="page-banner">
        <div className="page-banner-content">
          <h1>404 — Page Not Found</h1>
          <p>The page you're looking for doesn't exist.</p>
        </div>
      </div>
      <div className="section" style={{ textAlign: 'center' }}>
        <div className="container">
          <a href="/" className="btn btn-primary">Back to Home</a>
        </div>
      </div>
    </main>
  );
}

export default function App() {
  return (
    <BookingProvider>
      <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/rooms" element={<RoomsPage />} />
          <Route path="/rooms/:slug" element={<RoomDetails />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <FloatingButtons />
      </Router>
    </BookingProvider>
  );
}
